<template>
  <div class="left_bg"
       id="nav">
    <div class="nav-left">
      <div class="nav-left-item"
           id="index">
        <a title="首页"><img src="../../assets/images/index.jpg" /></a>
        <ul class="ul-first">
          <li>
            <a href="javascript:void(0)"
               class="arrow-down">首页<div class="arrow-left"></div></a>
            <ul class="ul-second">
              <li>
                <ul class="ul-thrid">
                  <li class="index"
                      @click.stop>
                    <router-link to="/">首页信息</router-link>
                  </li>
                  <li class="index"
                      @click.stop
                      v-if="(type=='0'||type=='2')&& menuList.indexOf(221010)>-1">
                    <router-link to="/indexNew">新首页信息</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="nav-left-item"
           id="report"
           v-if="pers.isShowBusinessData||pers.isShowZHReportData||pers.isShowFinanceData||(pers.isShowFudanData&&isShowFudan)||(pers.isShowHongKongPlazaData&&isShowHongKongPlaza)||(pers.isShowZhaBeiPlazaData&&isShowZhaBeiPlaza)||(pers.isShowGungaAirData&&isShowGungaAirport)||(pers.isShowYangZiJiangData&&isShowYangZiJiangReport)||(isShowTJTHCReport&&pers.isShowTJTHCData)||(isShowBGGCReport&&pers.isShowBGGCData)||(isShowXHLReport&&pers.isShowXHLData)||(isShowHSDSReport&&pers.isShowHSDSData)||(isShowBJXCReport&&pers.isShowBJXCData)||(isShowFuDanEhallCard&&pers.isShowFuDanEhallCardData)||(isShowCustCardSetUser&&pers.isShowCustCardSetUserData)">

        <a title="数据中心"><img src="../../assets/images/dataWhite.png" /></a>
        <ul class="ul-first">
          <li>
            <a href="javascript:void(0)"
               class="arrow-down">数据中心<div class="arrow-left"></div></a>
            <ul class="ul-second"
                v-if="pers.isShowBusinessData">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">业务报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="carPresentList"
                      @click.stop
                      v-if="menuList.indexOf(60010)>-1">
                    <router-link to="/carPresentList">在场数据查询</router-link>
                  </li>
                  <li class="carDepartureList"
                      @click.stop
                      v-if="menuList.indexOf(61010)>-1">
                    <router-link to="/carDepartureList">离场数据查询</router-link>
                  </li>
                  <li class="greenCarPresentList"
                      @click.stop
                      v-if="menuList.indexOf(600010)>-1">
                    <router-link to="/greenCarPresentList">绿牌车在场数据查询</router-link>
                  </li>
                  <li class="greenCarDepartureList"
                      @click.stop
                      v-if="menuList.indexOf(610010)>-1">
                    <router-link to="/greenCarDepartureList">绿牌车离场数据查询</router-link>
                  </li>
                  <li class="carAppselHisList"
                      @click.stop
                      v-if="menuList.indexOf(68410)>-1">
                    <router-link to="/carAppselHisList">时段优免数据查询</router-link>
                  </li>
                  <li class="freeTimePlateList"
                      @click.stop
                      v-if="menuList.indexOf(1027010)>-1">
                    <router-link to="/freeTimePlateList?type=1">时段优免设置查询</router-link>
                  </li>
                  <li class="handoverList"
                      @click.stop
                      v-if="menuList.indexOf(64010)>-1">
                    <router-link to="/handoverList">交班数据查询</router-link>
                  </li>
                  <li class="couponUsageList"
                      @click.stop
                      v-if="menuList.indexOf(69090)>-1">
                    <router-link to="/couponUsageList">优惠券使用报表</router-link>
                  </li>
                  <li class="carInList"
                      @click.stop
                      v-if="menuList.indexOf(62010)>-1">
                    <router-link to="/carInList">进场开闸查询</router-link>
                  </li>
                  <li class="carOutList"
                      @click.stop
                      v-if="menuList.indexOf(63010)>-1">
                    <router-link to="/carOutList">出场开闸查询</router-link>
                  </li>

                  <li class="chargeDetailList"
                      @click.stop
                      v-if="menuList.indexOf(65010)>-1">
                    <router-link to="/chargeDetailList">收费明细查询</router-link>
                  </li>

                  <li class="couponList"
                      @click.stop
                      v-if="menuList.indexOf(69210)>-1">
                    <router-link to="/couponList">优惠券领取报表</router-link>
                  </li>
                  <li class="couponList"
                      @click.stop
                      v-if="menuList.indexOf(1050010)>-1">
                    <router-link to="/eCouponReport">电子优惠券领取使用报表</router-link>
                  </li>
                  <li class="eCashPayList"
                      @click.stop
                      v-if="menuList.indexOf(69310)>-1">
                    <router-link to="/eCashPayList">现金微信支付宝明细报表</router-link>
                  </li>
                  <li class="redPacketList"
                      @click.stop
                      v-if="menuList.indexOf(69410)>-1">
                    <router-link to="/redPacketList">微信红包找零报表</router-link>
                  </li>

                  <!-- <li class="epayExceptionList"
                      @click.stop
                      v-if="menuList.indexOf(69010)>-1">
                    <router-link to="/epayExceptionList?type=0">支付异常报表</router-link>
                  </li> -->
                  <li class="cloudSeatData"
                      @click.stop
                      v-if="menuList.indexOf(1170010)>-1">
                    <router-link to="/cloudSeatData">云坐席操作记录</router-link>
                  </li>
                  <li class="pasOrOutVehicleStatisticsList"
                      @click.stop
                      v-if="menuList.indexOf(1100010)>-1">
                    <router-link to="/pasOrOutVehicleStatisticsList">每日进出车统计报表</router-link>
                  </li>
                  <li class="shAppUploadList"
                      @click.stop
                      v-if="menuList.indexOf(1120010)>-1">
                    <router-link to="/shAppUploadList">车位状态报表</router-link>
                  </li>
                  <li class="abnormalVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1042010)>-1">
                    <router-link to="/abnormalVehicles?type=4">异常车辆报表</router-link>
                  </li>
                  <li class="tempCarFreeDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1043010)>-1">
                    <router-link to="/tempCarFreeDeparture?type=4">临时车免费离场报表</router-link>
                  </li>
                  <li class="tempCarHandFreeDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1044010)>-1">
                    <router-link to="/tempCarHandFreeDeparture?type=1">临时车手动免费放行报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="ul-second"
                v-if="pers.isShowFinanceData">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">财务报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="custChargeReport"
                      @click.stop
                      v-if="menuList.indexOf(67010)>-1">
                    <router-link to="/custChargeReport">收费汇总报表</router-link>
                  </li>
                  <li class="dailyChargeReport"
                      @click.stop
                      v-if="menuList.indexOf(66010)>-1">
                    <router-link to="/dailyChargeReport">每日收费报表</router-link>
                  </li>
                  <li class="paymentDetailsReport"
                      @click.stop
                      v-if="menuList.indexOf(67110)>-1">
                    <router-link to="/paymentDetailsReport">支付明细报表</router-link>
                  </li>
                  <li class="paymentSummary"
                      @click.stop
                      v-if="menuList.indexOf(68210)>-1">
                    <router-link to="/paymentSummary">场库对账明细表报表</router-link>
                  </li>
                  <li class="reconciliationDetail"
                      @click.stop
                      v-if="menuList.indexOf(682010)>-1">
                    <router-link to="/reconciliationDetail?type=2">离场车辆对账明细报表</router-link>
                  </li>
                  <!-- <li class="paymentSummaryNew"
                      @click.stop
                      v-if="menuList.indexOf(68510)>-1">
                    <router-link to="/paymentSummaryNew">场库对账明细表报表(新)</router-link>
                  </li> -->
                  <!-- <li class="paymentSummaryOld"
                      @click.stop
                      v-if="menuList.indexOf(68310)>-1">
                    <router-link to="/paymentSummaryOld">场库对账明细表报表(历史数据)</router-link>
                  </li> -->
                  <li class="ePayTodayList"
                      @click.stop
                      v-if="menuList.indexOf(1198010)>-1">
                    <router-link to="/ePayTodayList?type=0">电子支付明细报表(当日)</router-link>
                  </li>
                  <li class="payDataList"
                      @click.stop
                      v-if="menuList.indexOf(68010)>-1">
                    <router-link to="/payDataList?type=0">电子支付明细报表(历史)</router-link>
                  </li>
                  <li class="eInvoiceDataList"
                      @click.stop
                      v-if="menuList.indexOf(69510)>-1">
                    <router-link to="/eInvoiceDataList">电子发票明细报表</router-link>
                  </li>
                  <li class="payDayDataList"
                      @click.stop
                      v-if="menuList.indexOf(68110)>-1">
                    <router-link to="/payDayDataList?type=0">电子支付每日汇总报表</router-link>
                  </li>
                  <li class="monthlyCardPaymet"
                      @click.stop
                      v-if="menuList.indexOf(69710)>-1">
                    <router-link to="/monthlyCardPaymet?type=0">电子支付月卡续费报表</router-link>
                  </li>
                  <li class="couPurPayList"
                      @click.stop
                      v-if="menuList.indexOf(1181010)>-1">
                    <router-link to="/couPurPayList">电子优惠券购买明细报表</router-link>
                  </li>
                  <li class="paymentReconciliation"
                      @click.stop
                      v-if="menuList.indexOf(1010010)>-1">
                    <router-link to="/paymentReconciliation">电子支付异常核对报表</router-link>
                  </li>
                  <li class="etcPayDataList"
                      @click.stop
                      v-if="menuList.indexOf(69110)>-1">
                    <router-link to="/etcPayDataList">ETC清算报表</router-link>
                  </li>
                  <li class="rechargeCardList"
                      @click.stop
                      v-if="menuList.indexOf(1020010)>-1">
                    <router-link to="/rechargeCardList">月卡续费报表</router-link>
                  </li>
                  <li class="paymentChannelList"
                      @click.stop
                      v-if="menuList.indexOf(1180010)>-1">
                    <router-link to="/paymentChannelList">各支付通道统计报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="ul-second"
                v-if="pers.isShowZHReportData">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">综合报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="bgMobDetail"
                      @click.stop
                      v-if="menuList.indexOf(1280010)>-1">
                    <router-link to="/bgMobDetail?type=2">对账明细报表</router-link>
                  </li>
                  <li class="tempCarFreeDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1281010)>-1">
                    <router-link to="/tempCarFreeDeparture?type=6">临时车免费离场报表</router-link>
                  </li>
                  <li class="tempCarHandFreeDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1282010)>-1">
                    <router-link to="/tempCarHandFreeDeparture?type=3">临时车手动免费放行报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="pers.isShowFudanData&&isShowFudan">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">复旦定制报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="illegalReport"
                      @click.stop
                      v-if="menuList.indexOf(69610)>-1">
                    <router-link to="/illegalReport">违章记录查询</router-link>
                  </li>
                  <li class="geomagneticBusMain"
                      @click.stop
                      v-if="menuList.indexOf(69810)>-1">
                    <router-link to="/geomagneticBusMain">地磁信息查询</router-link>
                  </li>
                  <li class="parkChnlVehicles"
                      @click.stop
                      v-if="menuList.indexOf(69910)>-1">
                    <router-link to="/parkChnlVehicles">车辆进出统计</router-link>
                  </li>
                  <li class="parkPlaceChar"
                      @click.stop
                      v-if="menuList.indexOf(300010)>-1">
                    <router-link to="/parkPlaceChar">场库车位统计</router-link>
                  </li>
                  <li class="plateCorrectData"
                      @click.stop
                      v-if="menuList.indexOf(310010)>-1">
                    <router-link to="/plateCorrectData">车牌修正报表</router-link>
                  </li>
                  <li class="carOffCarResPreList"
                      @click.stop
                      v-if="menuList.indexOf(1040010)>-1">
                    <router-link to="/carOffCarResPreList">公务车进出数据查询</router-link>
                  </li>
                  <li class="carOffEhallCardList"
                      @click.stop
                      v-if="menuList.indexOf(1041010)>-1">
                    <router-link to="/carOffEhallCardList">外协车进出数据查询</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="pers.isShowHongKongPlazaData&&isShowHongKongPlaza">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">香港广场定制报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="unionPayDetail"
                      @click.stop
                      v-if="menuList.indexOf(880010)>-1">
                    <router-link to="/unionPayDetail">场库对账明细报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="cardRecByMonth"
                      @click.stop
                      v-if="menuList.indexOf(881010)>-1">
                    <router-link to="/cardRecByMonth">月租停车明细表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="recAndCntByGrp"
                      @click.stop
                      v-if="menuList.indexOf(882010)>-1">
                    <router-link to="/recAndCntByGrp">月租停车汇总报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="unionCouponPay"
                      @click.stop
                      v-if="menuList.indexOf(883010)>-1">
                    <router-link to="/unionCouponPay">抵用金额日明细及日汇总</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="parkingPayDaySum"
                      @click.stop
                      v-if="menuList.indexOf(884010)>-1">
                    <router-link to="/parkingPayDaySum">临时停车日汇总报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="hotelDay"
                      @click.stop
                      v-if="menuList.indexOf(886010)>-1">
                    <router-link to="/hotelDay">寰星酒店停车日汇总表</router-link>
                  </li>
                </ul>
                <!--<ul class="ul-thrid" id="fold">-->
                <!--<li class="hotelMonthDay"-->
                <!--@click.stop-->
                <!--v-if="menuList.indexOf(885010)>-1">-->
                <!--<router-link to="/hotelMonthDay">寰星酒店月租车日汇总</router-link>-->
                <!--</li>-->
                <!--</ul>-->
                <!--<ul class="ul-thrid" id="fold">-->
                <!--<li class="hotelCouponDay"-->
                <!--@click.stop-->
                <!--v-if="menuList.indexOf(886010)>-1">-->
                <!--<router-link to="/hotelCouponDay">寰星酒店优惠券日汇总</router-link>-->
                <!--</li>-->
                <!--</ul>-->
                <ul class="ul-thrid" id="fold">
                  <li class="parkingPayMonthSum"
                      @click.stop
                      v-if="menuList.indexOf(887010)>-1">
                    <router-link to="/parkingPayMonthSum">停车场月度统计分析表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="(pers.isShowZhaBeiPlazaData&&isShowZhaBeiPlaza)">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">闸北广场定制报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="unionPayDetailZB"
                      @click.stop
                      v-if="menuList.indexOf(1190010)>-1">
                    <router-link to="/unionPayDetail?type=1">场库对账明细报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="cardRecByMonthZB"
                      @click.stop
                      v-if="menuList.indexOf(1191010)>-1">
                    <router-link to="/cardRecByMonth?type=1">月租停车明细表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="recAndCntByGrpZB"
                      @click.stop
                      v-if="menuList.indexOf(1192010)>-1">
                    <router-link to="/recAndCntByGrp?type=1">月租停车汇总报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="unionCouponPayZB"
                      @click.stop
                      v-if="menuList.indexOf(1193010)>-1">
                    <router-link to="/unionCouponPay?type=1">抵用金额日明细及日汇总</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="parkingPayDaySumZB"
                      @click.stop
                      v-if="menuList.indexOf(1194010)>-1">
                    <router-link to="/parkingPayDaySums">临时停车日汇总报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="parkingPayMonthSumZB"
                      @click.stop
                      v-if="menuList.indexOf(1197010)>-1">
                    <router-link to="/parkingPayMonthSum?type=1">停车场月度统计分析表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="pers.isShowGungaAirData&&isShowGungaAirport">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">贡嘎机场定制报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="reconciliationDetail"
                      @click.stop
                      v-if="menuList.indexOf(1006010)>-1">
                    <router-link to="/reconciliationDetail">离场车辆对账明细报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="monthlyCarDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1005010)>-1">
                    <router-link to="/monthlyCarDeparture">月车离场数据报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="tempCarFreeDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1004010)>-1">
                    <router-link to="/tempCarFreeDeparture">临时车免费离场报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="uniformedVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1002010)>-1">
                    <router-link to="/uniformedVehicles">军警车辆报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="gGAbnormalVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1003010)>-1">
                    <router-link to="/gGAbnormalVehicles">异常车辆报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="unionPaySensorlessPayment"
                      @click.stop
                      v-if="menuList.indexOf(1009010)>-1">
                    <router-link to="/cashPaymentDetail">现金支付明细报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="unionPaySensorlessPayment"
                      @click.stop
                      v-if="menuList.indexOf(1007010)>-1">
                    <router-link to="/unionPaySensorlessPayment?fPayTypeID=71300">银联无感支付报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="unionPaySensorlessPayment"
                      @click.stop
                      v-if="menuList.indexOf(1008010)>-1">
                    <router-link to="/unionPaySensorlessPayment?fPayTypeID=71000">银联非无感支付报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="weChatAlipayPayment"
                      @click.stop
                      v-if="menuList.indexOf(1008110)>-1">
                    <router-link to="/weChatAlipayPayment">微信支付宝支付报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="pers.isShowYangZiJiangData&&isShowYangZiJiangReport">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">扬子江丽笙酒店报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="reconciliationDetail"
                      @click.stop
                      v-if="menuList.indexOf(1015010)>-1">
                    <router-link to="/reconciliationDetail?type=1">离场车辆对账明细报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="monthlyCarDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1014010)>-1">
                    <router-link to="/monthlyCarDeparture?type=1">月车离场数据报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="tempCarFreeDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1013010)>-1">
                    <router-link to="/tempCarFreeDeparture?type=1">临时车免费离场报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="uniformedVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1011010)>-1">
                    <router-link to="/uniformedVehicles?type=1">军警车辆报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="abnormalVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1012010)>-1">
                    <router-link to="/abnormalVehicles?type=1">异常车辆报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="eCouponReport"
                      @click.stop
                      v-if="menuList.indexOf(1016010)>-1">
                    <router-link to="/eCouponReport?type=1">电子优惠券领取使用报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="sCouponReport"
                      @click.stop
                      v-if="menuList.indexOf(1017010)>-1">
                    <router-link to="/sCouponReport">特殊优免查询报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="freeTimePlateList"
                      @click.stop
                      v-if="menuList.indexOf(1018010)>-1">
                    <router-link to="/freeTimePlateList">时段优免查询报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="isShowTJTHCReport&&pers.isShowTJTHCData">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">天津天河城定制报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="reconciliationDetail"
                      @click.stop
                      v-if="menuList.indexOf(1021010)>-1">
                    <router-link to="/mobDetail">对账明细报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="monthlyCarDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1022010)>-1">
                    <router-link to="/mobPassWork">收费汇总报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="monthlyCarDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1023010)>-1">
                    <router-link to="/monthlyCarDeparture?type=2">月车离场数据报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="tempCarFreeDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1024010)>-1">
                    <router-link to="/tempCarFreeDeparture?type=2">临时车免费离场报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="uniformedVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1025010)>-1">
                    <router-link to="/uniformedVehicles?type=2">军警车辆报表</router-link>
                  </li>
                </ul>
                <ul class="ul-thrid" id="fold">
                  <li class="abnormalVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1026010)>-1">
                    <router-link to="/abnormalVehicles?type=2">异常车辆报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="isShowBGGCReport&&pers.isShowBGGCData">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">缤谷广场定制报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="bgChargePreExeReport"
                      @click.stop
                      v-if="menuList.indexOf(1057010)>-1">
                    <router-link to="/bgChargePreExeReport">充电优免明细报表</router-link>
                  </li>
                  <li class="bgMobDetail"
                      @click.stop
                      v-if="menuList.indexOf(1031010)>-1">
                    <router-link to="/bgMobDetail">对账明细报表</router-link>
                  </li>
                  <li class="bgMobPassWork"
                      @click.stop
                      v-if="menuList.indexOf(1032010)>-1">
                    <router-link to="/bgMobPassWork">收费汇总报表</router-link>
                  </li>
                  <li class="bgCardMobDetail"
                      @click.stop
                      v-if="menuList.indexOf(1033010)>-1">
                    <router-link to="/bgCardMobDetail">包月车对账明细报表</router-link>
                  </li>
                  <li class="bgCardChargeReport"
                      @click.stop
                      v-if="menuList.indexOf(1034010)>-1">
                    <router-link to="/bgCardChargeReport">包月车收费汇总报表</router-link>
                  </li>
                  <li class="tempCarFreeDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1034010)>-1">
                    <router-link to="/tempCarFreeDeparture?type=3">临时车免费离场报表</router-link>
                  </li>
                  <li class="tempCarHandFreeDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1058010)>-1">
                    <router-link to="/tempCarHandFreeDeparture">临时车手动免费放行报表</router-link>
                  </li>
                  <li class="uniformedVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1034010)>-1">
                    <router-link to="/uniformedVehicles?type=3">军警车辆报表</router-link>
                  </li>
                  <li class="abnormalVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1034010)>-1">
                    <router-link to="/abnormalVehicles?type=3">异常车辆报表</router-link>
                  </li>
                  <li class="bgCashPaymentDetail"
                      @click.stop
                      v-if="menuList.indexOf(1059010)>-1">
                    <router-link to="/bgCashPaymentDetail">现金支付明细报表</router-link>
                  </li>
                  <li class="bgDayMobPassWork"
                      @click.stop
                      v-if="menuList.indexOf(1055010)>-1">
                    <router-link to="/bgDayMobPassWork">收费日汇总报表</router-link>
                  </li>
                  <li class="bgMonMobPassWork"
                      @click.stop
                      v-if="menuList.indexOf(1056010)>-1">
                    <router-link to="/bgMonMobPassWork">收费月汇总报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="isShowXHLReport&&pers.isShowXHLData">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">山钢和润旭辉里定制报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="bgMobDetail"
                      @click.stop
                      v-if="menuList.indexOf(1131010)>-1">
                    <router-link to="/bgMobDetail?type=1">对账明细报表</router-link>
                  </li>
                  <li class="bgMobPassWork"
                      @click.stop
                      v-if="menuList.indexOf(1132010)>-1">
                    <router-link to="/bgMobPassWork?type=1">收费汇总报表</router-link>
                  </li>
                  <li class="bgCardChargeReport"
                      @click.stop
                      v-if="menuList.indexOf(1133010)>-1">
                    <router-link to="/monthlyCarDeparture?type=3">月车离场数据报表</router-link>
                  </li>
                  <li class="tempCarFreeDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1135010)>-1">
                    <router-link to="/tempCarFreeDeparture?type=5">临时车免费离场报表</router-link>
                  </li>
                  <li class="tempCarHandFreeDeparture"
                      @click.stop
                      v-if="menuList.indexOf(1158010)>-1">
                    <router-link to="/tempCarHandFreeDeparture?type=2">临时车手动免费放行报表</router-link>
                  </li>
                  <li class="uniformedVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1136010)>-1">
                    <router-link to="/uniformedVehicles?type=4">军警车辆报表</router-link>
                  </li>
                  <li class="abnormalVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1137010)>-1">
                    <router-link to="/abnormalVehicles?type=5">异常车辆报表</router-link>
                  </li>
                  <li class="bgCashPaymentDetail"
                      @click.stop
                      v-if="menuList.indexOf(1159010)>-1">
                    <router-link to="/bgCashPaymentDetail?type=1">现金支付明细报表</router-link>
                  </li>
                  <li class="bgDayMobPassWork"
                      @click.stop
                      v-if="menuList.indexOf(1155010)>-1">
                    <router-link to="/bgDayMobPassWork?type=1">收费日汇总报表</router-link>
                  </li>
                  <li class="bgMonMobPassWork"
                      @click.stop
                      v-if="menuList.indexOf(1156010)>-1">
                    <router-link to="/bgMonMobPassWork?type=1">收费月汇总报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="isShowHSDSReport&&pers.isShowHSDSData">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">上海惠生大厦定制报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="wYCouponUsageList"
                      @click.stop
                      v-if="menuList.indexOf(1157010)>-1">
                    <router-link to="/wYCouponUsageList">物业优免使用报表</router-link>
                  </li>
                  <li class="hSCouponUsageList"
                      @click.stop
                      v-if="menuList.indexOf(1160010)>-1">
                    <router-link to="/hSCouponUsageList">优惠券使用报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="isShowBJXCReport&&pers.isShowBJXCData">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">北京兴创定制报表<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="bJXCCouponUsageList"
                      @click.stop
                      v-if="menuList.indexOf(1161010)>-1">
                    <router-link to="/bJXCCouponUsageList">场库优惠券使用报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="pers.isShowRoadData">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">路侧数据中心<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid" id="fold">
                  <li class="roadSideCarPresentList"
                      @click.stop
                      v-if="menuList.indexOf(110010)>-1">
                    <router-link to="/roadSideCarPresentList">在场数据查询</router-link>
                  </li>
                  <li class="roadSideCarDepartureList"
                      @click.stop
                      v-if="menuList.indexOf(120010)>-1">
                    <router-link to="/roadSideCarDepartureList">离场数据查询</router-link>
                  </li>
                  <li class="rsOutParkHisSum"
                      @click.stop
                      v-if="menuList.indexOf(280010)>-1">
                    <router-link to="/rsOutParkHisSum">离场历史数据统计</router-link>
                  </li>
                  <li class="outParkForYYB"
                      @click.stop
                      v-if="menuList.indexOf(260010)>-1">
                    <router-link to="/outParkForYYB">离场数据查询</router-link>
                  </li>
                  <li class="staffPerformanceList"
                      @click.stop
                      v-if="menuList.indexOf(130010)>-1">
                    <router-link to="/staffPerformanceList">员工绩效查询</router-link>
                  </li>
                  <li class="roadSideHandoverList"
                      @click.stop
                      v-if="menuList.indexOf(150010)>-1">
                    <router-link to="/roadSideHandoverList">交班数据查询</router-link>
                  </li>
                  <li class="payDataList"
                      @click.stop
                      v-if="menuList.indexOf(140010)>-1">
                    <router-link to="/payDataList?type=1">电子支付报表</router-link>
                  </li>
                  <li class="epayExceptionList"
                      @click.stop
                      v-if="menuList.indexOf(160010)>-1">
                    <router-link to="/epayExceptionList?type=1">支付异常报表</router-link>
                  </li>
                  <li class="roadSideCarTurnover"
                      @click.stop
                      v-if="menuList.indexOf(170010)>-1">
                    <router-link to="/roadSideCarTurnover">周转率报表</router-link>
                  </li>
                  <li class="roadSideEInvoiceDataList"
                      @click.stop
                      v-if="menuList.indexOf(171010)>-1">
                    <router-link to="/roadSideEInvoiceDataList?type=1">电子发票明细报表</router-link>
                  </li>
                  <li class="monthlyCardPaymet"
                      @click.stop
                      v-if="menuList.indexOf(270010)>-1">
                    <router-link to="/monthlyCardPaymet?type=1">电子支付月卡续费报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
          </li>
        </ul>
      </div>
      <!-- <div class="nav-left-item"
           id="coupon">
        <a title="优惠卷"><img src="../../assets/images/couponWhite.png" /></a>
      </div> -->
      <div class="nav-left-item"
           id="coupon"
           v-if="pers.isShowCoupon">
        <a title="优惠券管理"><img src="../../assets/images/couponWhite.png" /></a>
        <ul class="ul-first">
          <li>
            <a href="javascript:void(0)"
               class="arrow-down">优惠券<div class="arrow-left"></div></a>
            <ul class="ul-second">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">优惠券设置<div class="arrow-left"></div></a>
                <ul class="ul-thrid">
                  <li class="couponGroup"
                      @click.stop
                      v-if="menuList.indexOf(191010)>-1">
                    <router-link to="/couponGroup">优惠券分类</router-link>
                  </li>
                  <li class="couponBatch"
                      @click.stop
                      v-if="menuList.indexOf(200010)>-1">
                    <router-link to="/couponBatch">优惠券管理</router-link>
                  </li>
                  <li class="rechargeCoupon"
                      @click.stop
                      v-if="menuList.indexOf(1019010)>-1">
                    <router-link to="/rechargeCoupon">充值优惠券管理</router-link>
                  </li>
                  <li class="rechargeCouponTemplate"
                      @click.stop
                      v-if="menuList.indexOf(26410)>-1">
                    <router-link to="/rechargeCouponTemplate">充值优惠券销售模板管理</router-link>
                  </li>
                  <li class="sellerGroup"
                      @click.stop
                      v-if="menuList.indexOf(172010)>-1">
                    <router-link to="/sellerGroup">商户分组</router-link>
                  </li>
                  <li class="sellerMain"
                      @click.stop
                      v-if="menuList.indexOf(180010)>-1">
                    <router-link to="/sellerMain">商户管理</router-link>
                  </li>
                  <li class="couponType"
                      @click.stop
                      v-if="menuList.indexOf(190010)>-1">
                    <router-link to="/couponType">特殊优惠券</router-link>
                  </li>
                  <li class="couponQCode"
                      @click.stop
                      v-if="menuList.indexOf(201010)>-1">
                    <router-link to="/couponQCode">优惠券二维码</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="nav-left-item"
           id="rateMain"
           v-if="pers.isShowRate">
        <a title="费率设置"><img src="../../assets/images/feeWhite.png" /></a>
        <ul class="ul-first">
          <li>
            <a href="javascript:void(0)"
               class="arrow-down">费率<div class="arrow-left"></div></a>
            <ul class="ul-second">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">费率设置<div class="arrow-left"></div></a>
                <ul class="ul-thrid">
                  <li class="rateMain"
                      @click.stop
                      v-if="menuList.indexOf(50010)>-1">
                    <router-link to="/rateMain">费率列表</router-link>
                  </li>
                  <li class="tempRateMain"
                      @click.stop
                      v-if="menuList.indexOf(51010)>-1">
                    <router-link to="/tempRateMain">临时车费率分组</router-link>
                  </li>
                  <li class="holidayMain"
                      @click.stop
                      v-if="menuList.indexOf(52010)>-1">
                    <router-link to="/holidayMain">节假日管理</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="nav-left-item"
           id="cardMain"
           v-if="pers.isShowCard || pers.isShowCustomizedCard">
        <a title="月车管理"><img src="../../assets/images/cardWhite.png" /></a>
        <ul class="ul-first">
          <li>
            <a href="javascript:void(0)"
               class="arrow-down">月车<div class="arrow-left"></div></a>
            <ul class="ul-second" v-if="pers.isShowCard">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">月车管理<div class="arrow-left"></div></a>
                <ul class="ul-thrid">
                  <li class="cardGroupMain"
                      @click.stop
                      v-if="menuList.indexOf(31010)>-1">
                    <router-link to="/cardGroupMain">分组管理</router-link>
                  </li>
                  <li class="cardMain"
                      @click.stop
                      v-if="menuList.indexOf(30010)>-1">
                    <router-link to="/cardMain">月卡管理</router-link>
                  </li>
                  <li class="cardMainHis"
                      @click.stop
                      v-if="menuList.indexOf(900010)>-1">
                    <router-link to="/cardMainHis">月卡历史</router-link>
                  </li>
                  <li class="cardFeeMain"
                      @click.stop
                      v-if="menuList.indexOf(33010)>-1">
                    <router-link to="/cardFeeMain">月卡续费管理</router-link>
                  </li>
                  <li class="blackPlateMain"
                      @click.stop
                      v-if="menuList.indexOf(32010)>-1">
                    <router-link to="/blackPlateMain">黑名单管理</router-link>
                  </li>
                  <li class="deploymentMain"
                      @click.stop
                      v-if="menuList.indexOf(35010)>-1">
                    <router-link to="/deploymentMain">布控车管理</router-link>
                  </li>
                  <li class="parkReserveList"
                      @click.stop
                      v-if="menuList.indexOf(36010)>-1">
                    <router-link to="/parkReserveList">预约车辆管理</router-link>
                  </li>
                  <li class="filterPlateCodeMain"
                      @click.stop
                      v-if="menuList.indexOf(26210)>-1">
                    <router-link to="/filterPlateCodeMain">过滤车牌数据管理</router-link>
                  </li>
                  <li class="monthCardMain"
                      @click.stop
                      v-if="menuList.indexOf(26510)>-1">
                    <router-link to="/monthCardMain">月卡数据查询</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <div :style="isShowss">
            <ul v-cloak class="ul-second"
                v-if="isShowFuDanEhallCard&&pers.isShowFuDanEhallCardData">
              <li>
                <a href="javascript:void(0)"
                  v-if="menuList.indexOf(1039010)>-1 || menuList.indexOf(1039410)>-1 || menuList.indexOf(1039110)>-1 || menuList.indexOf(26310)>-1 || menuList.indexOf(26710)>-1"
                   class="arrow-down">复旦月卡管理<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid">
                  <li class="fuDanEhallCard"
                      @click.stop
                      v-if="menuList.indexOf(1039010)>-1">
                    <router-link to="/fuDanEhallCard">外协车辆管理</router-link>
                  </li>
                  <li class="reportingVehicles"
                      @click.stop
                      v-if="menuList.indexOf(1039410)>-1">
                    <router-link to="/reportingVehicles">报备车辆管理</router-link>
                  </li>
                  <li class="PlatCardGroup"
                      @click.stop
                      v-if="menuList.indexOf(1039110)>-1">
                    <router-link to="/PlatCardGroup">月卡分组管理</router-link>
                  </li>
                  <li class="cardConcentrateMain"
                      @click.stop
                      v-if="menuList.indexOf(26310)>-1">
                    <router-link to="/cardConcentrateMain">月卡集中管理</router-link>
                  </li>
                  <li class="ehallCardTimeoutMain"
                      @click.stop
                      v-if="menuList.indexOf(26710)>-1">
                    <router-link to="/ehallCardTimeoutMain">外协车超时停放车辆管理</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            </div>
            <ul v-cloak class="ul-second"
                v-if="isShowCustCardSetUser&&pers.isShowCustomizedCard">
              <li>
                <a href="javascript:void(0)"
                  v-if="menuList.indexOf(1039310)>-1"
                   class="arrow-down">月卡定制管理<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid">
                  <li class="customizedCardMain"
                      @click.stop
                      v-if="menuList.indexOf(1039310)>-1">
                    <router-link to="/customizedCardMain">定制月卡管理</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <ul v-cloak class="ul-second">
              <li>
                <a href="javascript:void(0)"
                  v-if="menuList.indexOf(1039110)>-1 || menuList.indexOf(26310)>-1"
                   class="arrow-down">平台月卡管理<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid">
                  <li class="PlatCardGroup"
                      @click.stop
                      v-if="menuList.indexOf(1039110)>-1">
                    <router-link to="/PlatCardGroup">月卡分组管理</router-link>
                  </li>
                  <li class="cardConcentrateMain"
                      @click.stop
                      v-if="menuList.indexOf(26310)>-1">
                    <router-link to="/cardConcentrateMain">月卡集中管理</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="nav-left-item"
           id="parkMain"
           v-if="pers.isShowPark||pers.isShowAdTemp||pers.isShowRoadPark||pers.isShowAliPark||pers.isShowParkingGuidance">
        <a title="场库管理"><img src="../../assets/images/parkWhite.png" /></a>
        <ul class="ul-first">
          <li>
            <a href="javascript:void(0)"
               class="arrow-down">停车场<div class="arrow-left"></div></a>
            <ul class="ul-second"
                v-if="pers.isShowPark">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">场库设置<div class="arrow-left"></div></a>
                <ul class="ul-thrid">
                  <li class="parkMain"
                      @click.stop
                      v-if="menuList.indexOf(21010)>-1">
                    <router-link to="/parkMain">场库管理</router-link>
                  </li>
                  <li class="channelMain"
                      @click.stop
                      v-if="menuList.indexOf(22010)>-1">
                    <router-link to="/channelMain">通道管理</router-link>
                  </li>
                  <li class="parkingLockMain"
                      @click.stop
                      v-if="menuList.indexOf(26010)>-1">
                    <router-link to="/parkingLockMain">场库车位锁管理</router-link>
                  </li>
                  <li class="parkingGeoMain"
                      @click.stop
                      v-if="menuList.indexOf(26110)>-1">
                    <router-link to="/parkingGeoMain">场库地磁管理</router-link>
                  </li>
                  <li class="payOnline"
                      @click.stop
                      v-if="menuList.indexOf(23010)>-1">
                    <router-link to="/payOnline">电子支付设置</router-link>
                  </li>
                  <li class="paymentLink"
                      @click.stop
                      v-if="menuList.indexOf(24010)>-1">
                    <router-link to="/paymentLink">场库二维码</router-link>
                  </li>
                  <li class="seatQrCode"
                      @click.stop
                      v-if="menuList.indexOf(25010)>-1">
                    <router-link to="/seatQrCode">云坐席通道二维码</router-link>
                  </li>
                  <li class="shappRegister"
                      @click.stop
                      v-if="menuList.indexOf(1199010)>-1">
                    <router-link to="/shappRegister">上海停车G1G2注册</router-link>
                  </li>
                  <li class="otherSet"
                      @click.stop
                      v-if="menuList.indexOf(1199010)>-1">
                    <router-link to="/otherSet">第三方参数设置</router-link>
                  </li>
                  <!-- <li class="geomagneticMain"
                      @click.stop
                      v-if="menuList.indexOf(25010)>-1">
                    <router-link to="/geomagneticMain">地磁管理</router-link>
                  </li> -->
                </ul>
              </li>
            </ul>
            <ul class="ul-second"
                v-if="pers.isShowAdTemp">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">广告模板设置<div class="arrow-left"></div></a>
                <ul class="ul-thrid">
                  <li class="parkMain"
                      @click.stop
                      v-if="menuList.indexOf(1000010)>-1">
                    <router-link to="/adTempMain">广告模板管理</router-link>
                  </li>
                  <li class="channelMain"
                      @click.stop
                      v-if="menuList.indexOf(1001010)>-1">
                    <router-link to="/adTempBizMain">广告发布管理</router-link>
                  </li>

                </ul>
              </li>
            </ul>
            <ul class="ul-second"
                v-if="pers.isShowRoadPark">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down"
                   @click.stop>路侧场库设置<div class="arrow-left"></div></a>
                <ul class="ul-thrid">
                  <li class="roadSideParkMain"
                      @click.stop
                      v-if="menuList.indexOf(80010)>-1">
                    <router-link to="/roadSideParkMain">场库管理</router-link>
                  </li>
                  <li class="parkPlace"
                      @click.stop
                      v-if="menuList.indexOf(81010)>-1">
                    <router-link to="/parkPlace">场库车位管理</router-link>
                  </li>
                  <li class="pdaMain"
                      @click.stop
                      v-if="menuList.indexOf(82010)>-1">
                    <router-link to="/pdaMain">设备账号管理</router-link>
                  </li>
                  <li class="nbiotMain"
                      @click.stop
                      v-if="menuList.indexOf(250010)>-1">
                    <router-link to="/nbiotMain">地磁管理</router-link>
                  </li>
                  <li class="arrMain"
                      @click.stop
                      v-if="menuList.indexOf(83010)>-1">
                    <router-link to="/arrMain">欠费补缴管理</router-link>
                  </li>
                  <li class="departureDataMaintenance"
                      v-if="menuList.indexOf(84010)>-1"
                      @click.stop>
                    <router-link to="/departureDataMaintenance">离场数据维护</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="ul-second"
                v-if="pers.isShowAliPark">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down"
                   @click.stop>支付宝车主服务<div class="arrow-left"></div></a>
                <ul class="ul-thrid">
                  <li class="aliParkPID"
                      @click.stop
                      v-if="menuList.indexOf(90110)>-1">
                    <router-link to="/aliParkPID">支付宝场库ID管理</router-link>
                  </li>
                  <li class="aliParkMain"
                      @click.stop
                      v-if="menuList.indexOf(90010)>-1">
                    <router-link to="/aliParkMain">支付宝停车场管理</router-link>
                  </li>
                  <li class="ISVReg"
                      @click.stop
                      v-if="menuList.indexOf(100010)>-1">
                    <router-link to="/ISVReg">支付宝ISV管理</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="ul-second"
                v-if="pers.isShowParkingGuidance">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down"
                   @click.stop>车位引导设备管理<div class="arrow-left"></div></a>
                <ul class="ul-thrid">
                  <li class="parkDevCamMain"
                      @click.stop
                      v-if="menuList.indexOf(26610)>-1">
                    <router-link to="/parkDevCamMain">车位相机管理</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="nav-left-item"
           id="user"
           v-if="menuList.indexOf(10010)>-1">
        <a title="分组管理"><img src="../../assets/images/userWhite.png" /></a>
        <ul class="ul-first">
          <!-- :default-expand-all="true" -->
          <!-- :default-expanded-keys="expanded_keys" -->
          <el-tree :props="props"
                   :data="data"
                   empty-text=""
                   :default-expanded-keys="expanded_keys"
                   @node-click="handleNodeClick"
                   node-key="id"
                   ref="tree"
                   highlight-current>
          </el-tree>
        </ul>
      </div>
      <div class="nav-left-item"
           id="cust"
           v-if="pers.isShowCust">
        <a title="客户设置"><img src="../../assets/images/custWhite.png" /></a>
        <ul class="ul-first">
          <li>
            <a href="javascript:void(0)"
               class="arrow-down">客户<div class="arrow-left"></div></a>
            <ul class="ul-second">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">客户设置<div class="arrow-left"></div></a>
                <ul class="ul-thrid">
                  <li @click.stop
                      v-if="menuList.indexOf(40010)>-1">
                    <router-link to="/custMain">客户信息管理</router-link>
                  </li>
                  <li @click.stop
                      v-if="menuList.indexOf(41010)>-1">
                    <router-link to="/custSettingMain">客户运行设置</router-link>
                  </li>
                  <li @click.stop
                      v-if="menuList.indexOf(42010)>-1">
                    <router-link to="/custMaintenance">客户维保管理</router-link>
                  </li>
                  <li @click.stop
                      v-if="menuList.indexOf(43010)>-1">
                    <router-link to="/custMinProgSet">客户小程序功能设置</router-link>
                  </li>
                  <li @click.stop
                      v-if="menuList.indexOf(210010)>-1">
                    <router-link to="/custGroup">客户分组管理</router-link>
                  </li>
                  <!--<li @click.stop-->
                  <!--v-if="menuList.indexOf(330010)>-1">-->
                  <!--<router-link to="/sysInterfaceMain">接口管理</router-link>-->
                  <!--</li>-->
                  <li @click.stop
                      v-if="menuList.indexOf(340010)>-1">
                    <router-link to="/appMain">三方接口授权管理</router-link>
                  </li>
                  <li @click.stop
                      v-if="menuList.indexOf(240010)>-1">
                    <router-link to="/custKey">APP激活码管理</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="ul-second"
                v-if="isShowCustCardSetUser&&pers.isShowCustCardSetUserData">
              <li>
                <a href="javascript:void(0)"
                  v-if="menuList.indexOf(1039210)>-1"
                   class="arrow-down">客户定制月卡设置<div class="arrow-left" id="foldStyle"></div></a>
                <ul class="ul-thrid">
                  <li class="custCardSetUser"
                      @click.stop
                      v-if="menuList.indexOf(1039210)>-1">
                    <router-link to="/custCardSetUser">客户月卡分组设置</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="nav-left-item"
           id="device"
           v-if="pers.isShowDevice">
        <a title="设备管理"><img src="../../assets/images/deviceWhite.png" /></a>
        <ul class="ul-first">
          <li>
            <a href="javascript:void(0)"
               class="arrow-down">设备<div class="arrow-left"></div></a>
            <ul class="ul-second">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">设备管理<div class="arrow-left"></div></a>
                <ul class="ul-thrid">
                  <li class="deviceMain"
                      @click.stop
                      v-if="menuList.indexOf(70010)>-1">
                    <router-link to="/deviceMain">电脑信息</router-link>
                  </li>
                  <li class="mqttStatusMain"
                      @click.stop
                      v-if="menuList.indexOf(74010)>-1">
                    <router-link to="/mqttStatusMain">MQTT日志</router-link>
                  </li>
                  <li class="errorLogMain"
                      @click.stop
                      v-if="menuList.indexOf(71010)>-1">
                    <router-link to="/errorLogMain">异常日志</router-link>
                  </li>
                  <li class="channelLogMain"
                      @click.stop
                      v-if="menuList.indexOf(72010)>-1">
                    <router-link to="/channelLogMain">通道日志</router-link>
                  </li>
                  <li class="logMain"
                      @click.stop
                      v-if="menuList.indexOf(73010)>-1">
                    <router-link to="/logMain">程序日志</router-link>
                  </li>
                  <li class="cloudLog"
                      @click.stop
                      v-if="menuList.indexOf(75010)>-1">
                    <router-link to="/cloudLog">平台日志</router-link>
                  </li>
                  <li class="lcdLog"
                      @click.stop
                      v-if="menuList.indexOf(76010)>-1">
                    <router-link to="/lcdLog">LCD日志</router-link>
                  </li>
                  <li class="gateOperationLog"
                      @click.stop
                      v-if="menuList.indexOf(70110)>-1">
                    <router-link to="/gateOperationLog">门岗操作日志</router-link>
                  </li>
                  <li class="devAccLog"
                      @click.stop
                      v-if="menuList.indexOf(77010)>-1">
                    <router-link to="/devAccLog">手持机日志</router-link>
                  </li>
                  <li class="shra2019"
                      @click.stop
                      v-if="menuList.indexOf(78010)>-1">
                    <router-link to="/shra2019">上海路政</router-link>
                  </li>
                  <li class="equDvc"
                      @click.stop
                      v-if="menuList.indexOf(79010)>-1">
                    <router-link to="/equDvc">设备信息</router-link>
                  </li>
                  <li class="log"
                      @click.stop
                      v-if="menuList.indexOf(1060010)>-1">
                    <router-link to="/log">日志文件</router-link>
                  </li>
                  <li class="log"
                      @click.stop
                      v-if="menuList.indexOf(70010)>-1">
                    <router-link to="/parkMonitor">场库设备监测报表</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- <div class="nav-left-item"
           id="setting"
           v-if="menuList.indexOf(100010)>-1">
        <a title="设置管理"><img src="../../assets/images/setting.png" /></a>
        <ul class="ul-first">
          <li>
            <a href="javascript:void(0)"
               class="arrow-down">设置<div class="arrow-left"></div></a>
            <ul class="ul-second">
              <li>
                <a href="javascript:void(0)"
                   class="arrow-down">支付宝设置<div class="arrow-left"></div></a>
                <ul class="ul-thrid">
                  <li class="ISVReg"
                      @click.stop
                      v-if="menuList.indexOf(100010)>-1">
                    <router-link to="/ISVReg">ISV注册</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div> -->
      <!-- <div class="nav-left-item"
           id="editUserPwd">
        <a title="修改密码"><img src="../../assets/images/pwdWhite.png" /></a>
        <ul class="ul-first">
          <li>
            <a href="javascript:void(0)"
               class="arrow-down">修改密码<div class="arrow-left"></div></a>
            <ul class="ul-second">
              <li>
                <ul class="ul-thrid">
                  <li @click.stop>
                    <router-link to="/editUserPwd">修改密码</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import * as user from '../../api/user'
export default {
  name: 'left',
  data () {
    return {
      userId: '',
      data: [],
      nodeList: [],
      expanded_keys: [],
      isShowGungaAirport: true,
      isShowYangZiJiangReport: true,
      isShowFudan: true,
      isShowHongKongPlaza: true,
      isShowZhaBeiPlaza: true,
      isShowTJTHCReport: true,
      isShowBGGCReport: true,
      isShowXHLReport: true,
      isShowHSDSReport: true,
      isShowBJXCReport: true,
      isShowFuDanEhallCard: true,
      isShowCustCardSetUser: true,
      isShowss: 'display:none',
      props: {
        label: 'name',
        children: 'children'
      },
      routerParamsName: '闸北广场定制报表'
    }
  },
  props: {
    menuList: { type: Array, required: true },
    pers: { type: Object, required: true },
    type: { type: String, required: true }
  },
  created () {
    this.$emit('refreshLeft')
  },
  computed: {

  },
  methods: {
    ...mapActions([
      'getUserGroupData', 'setNode', 'setUserGroup'
    ]),
    addGroup (fGrpID, fLevel, fGrpName) {
      this.$router.push('/userGroupMain?fGrpID=' + fGrpID + '&fLevel=' + fLevel + '&fGrpName=' + fGrpName)
    },
    addRootGroup (fGrpID, fLevel) {
      this.$router.push('/userRootGroupMain?fGrpID=' + fGrpID + '&fLevel=' + fLevel)
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    updateLeftWdith (width) {
      this.$emit('updateLeftWdith', width)
    },
    onRefresList () {
      let _this = this
      if (!this.$route.meta.keepAlive) {
        return
      }
      $(window).resize(function () {
        $('.nav-left .ul-first').height($(window).height() - 62)
      })
      $('.nav-left .ul-first').height($(window).height() - 62)
      let menuArray = this.$route.meta.menuId.split('/')
      var menuId = menuArray[0]
      $('#' + menuId).addClass('active')
      if ($('#' + menuId)[0]) {
        $('#' + menuId).find('.ul-first').css({ 'display': 'block', 'width': '238px', 'top': '-' + $('#' + menuId)[0].offsetTop + 'px' })
      }
      if ($('#' + menuId).find('.ul-thrid>li').length > 0) {
        if (menuId !== 'user') {
          if (menuArray.length >= 2) {
            $('#' + menuId).find('.ul-thrid>li.' + menuArray[1]).addClass('selected')// 触发路由配置的菜单
          } else {
            $('#' + menuId).find('.ul-thrid>li').eq(0).addClass('selected')// 触发第一个子菜单
          }
        }
      }
      var id = $('.nav-left>.nav-left-item.active').attr('id')
      if (id === 'user') {
        if (_this.$refs.tree && _this.$refs.tree.getCurrentKey()) {
          var node = _this.$refs.tree.getCurrentNode()
          this.$router.push('/userGroup?fGrpID=' + node.id + '&fPGrpID=' + node.parentId + (node.children.length === 1 ? ('&fChildGrpID=' + node.children[0].id) : ''))
        } else {
          if (this.data.length > 0) {
            this.$router.push('/userGroup?fGrpID=' + this.data[0].id + '&fPGrpID=' + this.data[0].parentId + (_this.data[0].children.length === 1 ? ('&fChildGrpID=' + _this.data[0].children[0].id) : ''))
          }
        }
      }
      $('.nav-left>.nav-left-item>a').unbind('click')
      $('body').on('click', '.nav-left>.nav-left-item>a', function (event) {
        event.stopPropagation()
        let id = $(this).parent('.nav-left-item').attr('id')
        // $('#' + id).find('ul>li').removeClass('selected')
        $(this).parent('.nav-left-item').addClass('active')
        $(this).parent('.nav-left-item').siblings('.nav-left-item').removeClass('active')
        $('.ul-first').hide()
        $(this).parent('.nav-left-item').find('.ul-first').css({ 'display': 'block', 'width': '238px', 'top': '-' + $(this).parent('.nav-left-item')[0].offsetTop + 'px' })
        if (id !== 'user') {
          var url = $('#' + id).find('.ul-thrid>li>a').eq(0).attr('href')
          if (url) {
            url = url.substring(1)
            $('#' + id).find('.ul-thrid>li').removeClass('selected')
            $('#' + id).find('.ul-thrid>li').eq(0).addClass('selected')
            _this.$router.push({ path: url })
          }
        } else {
          if (_this.$refs.tree !== undefined) {
            var node = _this.$refs.tree.getCurrentNode()
            _this.$router.push('/userGroup?fGrpID=' + node.id + '&fPGrpID=' + node.parentId + (node.children.length === 1 ? ('&fChildGrpID=' + node.children[0].id) : ''))
          } else {
            if (_this.data.length > 0) {
              _this.$router.push('/userGroup?fGrpID=' + _this.data[0].id + '&fPGrpID=' + _this.data[0].parentId + (_this.data[0].children.length === 1 ? ('&fChildGrpID=' + _this.data[0].children[0].id) : ''))
            }
          }
        }
      })
      $('#' + menuId).trigger('click')
      $('.arrow-down').unbind('click')
      $('.arrow-down').click(function (event) {
        event.stopPropagation()
        if ($(this).hasClass('user-li-a')) {
          $('.nav-left-item li').removeClass('selected')
          $('.nav-left-item li').addClass('active')
          $(this).parent().addClass('selected')
        }
        if ($(this).siblings('ul').css('display') === 'none') {
          $(this).siblings('ul').slideDown(200)
          // $(this).parents('li').siblings('li').children('ul').slideUp(200);
          $(this).find('.arrow-left').css({
            marginTop: '-8px',
            transform: 'rotate(135deg)'
          })
        } else {
          $(this).find('.arrow-left').css({
            marginTop: '0px',
            transform: 'rotate(45deg)'
          })
          $(this).siblings('ul').slideUp(200)
        }
      })

      $('.nav-left-item').find('.ul-thrid>li').unbind('click')
      $('.nav-left-item').find('.ul-thrid>li').click(function (event) {
        event.stopPropagation()
        // $(this).siblings().removeClass('selected')
        $('.nav-left-item li>a').removeClass('selected')
        $('.nav-left-item li').removeClass('selected')
        $('.arrow-down').removeClass('selected')
        $('.nav-left-item').find('.ul-thrid>li').removeClass('selected')
        $(this).addClass('selected') // selected
      })
    },
    handleNodeClick (obj, node, tree) {
      this.$router.push('/userGroup?fGrpID=' + obj.id + '&fPGrpID=' + obj.parentId + (obj.children.length === 1 ? ('&fChildGrpID=' + obj.children[0].id) : ''))
      this.nodeList = []
      this.setNodeList(node)
      this.setNode(this.nodeList)
    },
    setNodeList (node) {
      this.nodeList.unshift(node.label)
      if (node.parent.label) {
        var pNode = this.$refs.tree.getNode(node.parent)
        this.setNodeList(pNode)
      }
    },
    appendNode (pNode, node) {
      if (pNode.id === node.parentId) {
        if ((pNode.children || []).length > 0) {
          pNode.children.push(node)
        } else {
          pNode.children = []
          pNode.children.push(node)
        }
      } else {
        for (let i = 0; i < (pNode.children || []).length; i++) {
          this.appendNode(pNode.children[i], node)
        }
      }
    },
    updateNode (pNode, node) {
      if (pNode.id === node.id) {
        pNode.name = node.name
      } else {
        for (let i = 0; i < (pNode.children || []).length; i++) {
          this.updateNode(pNode.children[i], node)
        }
      }
    },
    removeNode (pNode, node) {
      if (pNode.id === node.parentId) {
        for (let i = 0; i < (pNode.children || []).length; i++) {
          if (pNode.children[i].id === node.id) {
            pNode.children.splice(i, 1)
            break
          }
        }
      } else {
        for (let i = 0; i < (pNode.children || []).length; i++) {
          this.removeNode(pNode.children[i], node)
        }
      }
    }
  },
  mounted () {
    this.EventBus.$on('add', (node) => {
      this.appendNode(this.data[0], node)
    })
    this.EventBus.$on('edit', (node) => {
      this.updateNode(this.data[0], node)
    })
    this.EventBus.$on('remove', (node) => {
      // this.$refs.tree.remove(node)
      this.removeNode(this.data[0], node)
    })
    user.initConfig().then((res) => {
      let { data } = res
      if (data.IsOk) {
        this.isShowFudan = data.Data.isShowFudan
        this.isShowGungaAirport = data.Data.isShowGungaAirport
        this.isShowHongKongPlaza = data.Data.isShowHongKongPlaza
        this.isShowZhaBeiPlaza = data.Data.isShowZhaBeiPlaza
        this.isShowYangZiJiangReport = data.Data.isShowYangZiJiangReport
        this.isShowTJTHCReport = data.Data.isShowTJTHCReport
        this.isShowBGGCReport = data.Data.isShowBGGCReport
        this.isShowXHLReport = data.Data.isShowXHLReport
        this.isShowHSDSReport = data.Data.isShowHSDSReport
        this.isShowBJXCReport = data.Data.isShowBJXCReport
        this.isShowFuDanEhallCard = data.Data.isShowFuDanEhallCard
        this.isShowCustCardSetUser = data.Data.isShowCustCardSetUser
        this.isShowss = ''
      }
    })
    user.getGroupNode().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.data = data.Data || []
          this.setUserGroup(this.data)
          if (this.data.length > 0) {
            this.expanded_keys.push(this.data[0].id) // 展开第一个节点
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(this.data[0].id)
            })
          }
        } else {
          this.$message.error(data.Msg)
        }
      }
    })
  },
  updated () {
    var meta = this.$route.meta.menuId
    if (meta.indexOf('user') > -1) {
      if (this.$refs.tree) {
        var key = this.$refs.tree.getCurrentKey()
        if (key) {
          this.$refs.tree.setCurrentKey(key)
        }
      }
    }
    this.onRefresList()
  }
}
</script>
<style >
#nav .el-tree-node__content:hover {
  background-color: #4063b3 !important;
}

#nav .el-tree-node:focus > .el-tree-node__content {
  background-color: #4063b3 !important;
}
#nav
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #4063b3 !important;
}
</style>
<style scoped>
@import "../../assets/css/zui.css";
.ul-first {
  overflow-y: auto;
  overflow-x: auto;
}
.el-tree {
  background: #222 !important;
  color: #ffffff;
  min-width: 100%;
  display: inline-block !important;
}
.tree {
  overflow-y: hidden;
  overflow-x: scroll;
  /* width: 80px;
  height: 500px; */
}

.nav-left > .nav-left-item > a {
  display: inline-block;
}

#fold {
  display:none
}

#foldStyle {
  margin-top: 0px;
  transform: rotate(45deg)
}

[v-cloak]{
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/view/home/leftGroup.vue